import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

function Privacy() {
  const { brandName, contact } = siteConfig;

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="privacy policy-page">
      <header className="policy-page__hero">
        <p>Legal / Your data</p>
        <h1>Privacy policy</h1>
        <span>Last updated: August 2026</span>
      </header>

      <div className="policy-page__layout">
        <nav className="policy-page__nav" aria-label="Privacy policy contents">
          <p>On this page</p>
          <a href="#overview">Overview</a>
          <a href="#information">Information we collect</a>
          <a href="#use">How we use it</a>
          <a href="#sharing">Sharing and storage</a>
          <a href="#choices">Your choices</a>
          <a href="#contact-privacy">Contact</a>
        </nav>

        <article className="policy-page__content">
          <section id="overview">
            <p className="policy-page__kicker">Overview</p>
            <h2>Your information should be treated with care.</h2>
            <p>
              This policy explains how {brandName} handles personal information
              when you browse our store, place an order, contact our care team
              or choose to hear from us. We collect only what we need to provide
              those services and improve the shopping experience.
            </p>
          </section>

          <section id="information">
            <h2>1. Information we collect</h2>
            <p>
              Depending on how you use the site, this can include your contact
              and delivery details, order and payment confirmation data,
              messages to customer care, preferences, device information and
              basic browsing activity.
            </p>
            <ul>
              <li>Account and contact details you provide directly.</li>
              <li>Order, delivery, return and customer-care history.</li>
              <li>Cookie and device data used for essential site functions.</li>
              <li>Marketing preferences, only where you have made a choice.</li>
            </ul>
          </section>

          <section id="use">
            <h2>2. How we use information</h2>
            <p>
              We use personal information to process purchases, deliver and
              support orders, prevent fraud, keep the store secure, meet legal
              duties and understand how our services perform. Promotional
              messages are sent only where permitted, and you can opt out at
              any time.
            </p>
          </section>

          <section id="sharing">
            <h2>3. Sharing and storage</h2>
            <p>
              We may share the minimum necessary information with trusted
              providers such as payment processors, delivery partners, hosting
              services and customer-support tools. They may use it only to
              perform the agreed service or meet their own legal obligations.
              We do not sell your personal information.
            </p>
            <p>
              Retention periods depend on why the information was collected.
              We remove or anonymize it when it is no longer required, unless a
              longer period is needed for tax, accounting, fraud prevention or
              another legal reason.
            </p>
          </section>

          <section id="choices">
            <h2>4. Your choices and rights</h2>
            <p>
              Subject to local law, you may ask to access, correct, delete or
              restrict personal information, object to certain processing or
              receive a portable copy. You may also withdraw consent for future
              processing at any time.
            </p>
            <p>
              Essential cookies keep the cart and checkout working. Optional
              analytics or advertising cookies should follow the preference you
              select in the cookie controls available on the site.
            </p>
          </section>

          <section id="contact-privacy">
            <h2>5. Questions about your data</h2>
            <p>
              Email <a href={`mailto:${contact.email}`}>{contact.email}</a> or
              write to {contact.address}. To help us protect your information,
              we may need to verify your identity before completing a request.
            </p>
            <Link to="/contact" onClick={toTop} className="policy-page__button">
              Contact customer care
            </Link>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Privacy;
